module.exports = __webpack_public_path__ + "img/ve.47e8da70.png";